export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
            <path d="M25 15.625V42.7083" stroke="white" strokeWidth="3.125" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7507 8.33398H19.7923C22.6688 8.33398 25.0007 10.6658 25.0007 13.5423V16.6673H18.7507C16.4495 16.6673 14.584 14.8018 14.584 12.5007C14.584 10.1995 16.4495 8.33398 18.7507 8.33398Z"
                stroke="white"
                strokeWidth="3.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.2493 8.33398H30.2077C27.3312 8.33398 24.9993 10.6658 24.9993 13.5423V16.6673H31.2493C33.5505 16.6673 35.416 14.8018 35.416 12.5007C35.416 10.1995 33.5505 8.33398 31.2493 8.33398Z"
                stroke="white"
                strokeWidth="3.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.416 25H39.5827V42.75C39.5827 43.3023 39.135 43.75 38.5827 43.75H11.416C10.8637 43.75 10.416 43.3023 10.416 42.75V25Z"
                stroke="white"
                strokeWidth="3.125"
            />
            <rect width="37.5" height="8.33333" rx="1" transform="matrix(1 0 0 -1 6.25 25)" stroke="white" strokeWidth="3.125" />
        </svg>
    );
}
